export default {
  title: 'ЦРФ',
  notFound: 'Тражена страница није пронађена',
  user: {
    username: 'Корисничко име',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    email: 'И-мејл',
    firstTimeLogin: 'Пријављујем се први пут',
    passwordForgotten: 'Заборављена лозинка',
    passwordResetLinkSent: 'Линк за поновно постављање лозинке је послат на вашу адресу електронске поште'
  },
  general: {
    phone: 'Број телефона',
    email: 'Адреса електронске поште',
    changelog: 'Информације о верзијама сервиса',
    technicalSupport: 'Пријава проблема',
    integration: 'Инструкције за интеграцију'
  },
  forms: {
    ok: 'У реду',
    cancel: 'Одустани',
    submit: 'Потврди',
    send: 'Пошаљи',
    close: 'Затвори',
    save: 'Сачувај',
    apply: 'Примени',
    edit: 'Измени',
    warning: 'Упозорење',
    notification: 'Обавештење',
    load: 'Учитај',
    saveToFile: 'Сачувај у фајл',
    saveToDiagnosticFile: 'Сачувај у дијагностички фајл',
    saveToClipboard: 'Сачувај у клипборд',
    capsLockOn: 'Укључен је CapsLock'
  },
  dashboard: {
    welcome: 'Добродошли',
    liabilitiesRegisteredTotal: 'Укупно регистрованих фактура данас',
    liabilitiesRegisteredDebtor: 'Као дужник',
    liabilitiesRegisteredCreditor: 'Као поверилац',
    liabilitiesRegistrationLimit: 'Месечни лимит на број регистрованих фактура'
  },
  sidebar: {
    allInvoices: 'Све фактуре',
    registerInvoice: 'Регистрација фактуре',
    userAdministration: 'Администрација',
    userRegistration: 'Регистрација институције',
    reportedIssues: 'Рекламације',
    groupSettlement: 'Спецификација групног плаћања',
    invoiceSettlement: 'Измирење фактуре',
    intervention: 'Интервенције'
  },
  activation: {
    title: 'Активација корисника',
    success: 'Корисник успешно активиран',
    activationSent: 'Линк за активацију корисника је послат на вашу адресу електронске поште'
  },
  reset: {
    title: 'Постављање лозинке',
    success: 'Корисничка лозинка успешно постављена'
  },
  issues: {
    reportIssue: 'Пријава проблема',
    reportIssueDetails: 'Информације о рекламацији',
    reportIssueSuccess: 'Проблем успешно пријављен',
    reportIssueLiability: 'Проблем регистрације фактуре',
    reportIssueSettlement: 'Проблем измирења фактуре',
    reportId: 'Идентификатор',
    reportSettlementId: 'Идентификатор измирења',
    reportCategories: 'Категорија проблема',
    reportData: 'Додатне информације',
    reportSettlementAmount: 'Износ измирења',
    reportUserComment: 'Коментар корисника',
    reportOperatorComment: 'Коментар оператера',
    reportColumnCategory: 'Категорија',
    reportColumnCreationDate: 'Датум креирања',
    reportColumnClosingDate: 'Датум затварања',
    reportColumnData: 'Податак',
    reportColumnResourceId: 'Идентификатор',
    reportColumnStatus: 'Статус',
    reportColumnCompanyNumber: 'ЈБКЈС',
    reportIssueStatus: {
      0: 'Све',
      1: 'Активна',
      2: 'Отказана',
      3: 'Решена',
      4: 'Нерешена'
    },
    reportIssueCancel: 'Откажи рекламацију',
    reportIssueResolve: 'Затвори рекламацију',
    reportIssueCancelModal: 'Откажи рекламацију',
    reportIssueCancelModalConfirm: 'Да ли желите да откажете рекламацију?',
    reportIssueCancelSuccess: 'Рекламација успешно отказана',
    reportIssueResolveModal: 'Затвори рекламацију',
    reportIssueResolveSuccess: 'Рекламација успешно затворена',
    reportIssueResolved: 'Означи као решена',
    reportIssueUnresolved: 'Означи као нерешена',
    reportIssueResolveComment: 'Коментар затварања',
    reportIssueUserLogin: 'Корисничко име',
    reportIssueUserName: 'Име и презиме',
    reportIssueUserOrganization: 'Организација',
    reportIssueBank: 'Банка',
    reportIssueBankFeedback: 'Банка мора садржати 3 карактера',
    reportIssueHelpLink: 'Детаљно упутство',
    reportIssues: 'Рекламације',
    reportIssuesActive: 'Активне',
    reportIssuesAll: 'Све'
  },
  register: {
    title: 'Регистрација',
    registrationForbidden: 'Регистрација правног лица/органа није дозвољена у овом тренутку',
    legalEntityInfo: 'Подаци о правном лицу/органу',
    legalEntityCheckboxText: 'Региструјем се као ПРИВАТНО ПРАВНО ЛИЦЕ',
    budgetIdNumber: 'ЈБКЈС*',
    budgetIdNumberFootnote: '*Попуњава правно лице/орган које има додељен ЈБКЈС',
    companyNumber: 'Матични број',
    companyNumberShort: 'МБ',
    taxIdNumber: 'ПИБ',
    parentCompany: 'Надређена институција',
    companyName: 'Назив правног лица/органа',
    legalEntityName: 'Име јавног предузећа',
    address: 'Адреса седишта',
    postalCode: 'Поштански број',
    treasuryBranchInfo: 'Подаци o организационој јединици Управе за Tрезор',
    treasuryBranch: 'Број организационе јединице',
    treasuryBranchNote: 'укуцајте првих неколико слова града/општине и систем ће приказати предлоге',
    email: 'Адреса електронске поште',
    adminInfo: 'Подаци о администратору',
    name: 'Име и презиме',
    personalIdentityNumber: 'ЈМБГ',
    identityNumber: 'Број идентификационе исправе',
    submit: 'Пошаљи захтев за регистрацију',
    infoText: 'Након успешно попуњеног захтева, добићете и-мејл поруку од Управе за Трезор са детаљима корака регистрације.',
    registrationSuccess: 'Регистрација успешно обављена.',
    registrationSuccessText: 'Проверите да ли сте добили потврдни и-мејл од Управе за Трезор. Уколико потврда није стигла, запишите податке са овог обавештења и преузмите регистрациони налог кликом на дугме \'Преузимање захтева\'',
    registrationLimitExceeded: 'Прекорачили сте број сукцесивних захтева за регистрацију, молимо сачекајте 10 секунди па покушајте поново',
    printRequestForm: 'Преузимање захтева',
    printForm: 'Преузимање потврде',
    ouList: 'Листа организационих јединица',
    editRegistration: 'Уколико желите да измените већ поднету регистрацију, притисните дугме \'Учитај регистрацију\' и унесите токен за измену регистрације како бисте учитали регистроване податке.',
    editRegistrationLine2: 'Након унетих измена, сачувајте их притиском на дугме \'Пошаљи захтев за регистрацију\'',
    editRegistrationButton: 'Измени регистрацију',
    editRegistrationToken: 'Токен за измену регистрације',
    editRegistrationLoad: 'Учитавање података за измену',
    registrationLoad: 'Учитај регистрацију'
  },
  invoices: {
    invoiceIndex: 'Индекс фактуре',
    invoiceReview: 'Преглед фактура',
    review: 'преглед',
    invoiceDetails: 'Информације о фактури',
    invoiceId: 'Идентификатор фактуре',
    settlementDetails: 'Информације о измирењима',
    cancelInvoice: 'Откажи фактуру',
    cancel: 'Откажи',
    cancelSettlement: 'Откажи измирење',
    settleInvoice: 'Измири фактуру',
    settlementPaymentId: 'Идентификатор плаћања',
    settlementAmount: 'Износ измирења',
    cancelInvoices: 'Откажи фактурe',
    cancellationUser: 'Отказао',
    cancellationDate: 'Датум отказивања',
    cancellationComment: 'Разлог отказивања',
    cancellationSuccess: 'Фактуре успешно отказане',
    bank: 'Банка',
    columnCreditor: 'Поверилац',
    columnDebtor: 'Дужник',
    columnId: 'Идентификатор',
    columnBudgetIdNumber: 'ЈБКЈС дужника',
    columnInvoiceNumber: 'Број фактуре',
    columnInvoiceAmount: 'Износ',
    columnInvoiceAmountFrom: 'Oд',
    columnInvoiceAmountTo: 'До',
    columnSelected: 'Означи',
    columnSettlementAmount: 'Износ за измирење',
    columnSettlementDate: 'Датум измирења',
    columnInvoiceStatus: 'Статус',
    columnCreditorName: 'Назив повериоца',
    columnDebtorName: 'Назив дужника',
    columnCreditorBudgetIdNumber: 'ЈБКЈС повериоца',
    columnCreditorTaxId: 'ПИБ повериоца',
    columnCreditorCompanyNumber: 'МБ повериоца',
    columnDueDate: 'Законски рок измирења',
    columnPreviousDueDate: 'Претходни рок измирења',
    columnDueDateRangeFrom: 'Oд',
    columnDueDateRangeTo: 'До',
    columnCreationDate: 'Датум креирања',
    columnCreationDateRangeFrom: 'Од',
    columnCreationDateRangeTo: 'До',
    columnLifetime: 'Рок важења',
    columnSettlementComments: 'Коментар измирења',
    columnSettlementStatus: 'Статус',
    columnSettledAmount: 'Измирени износ',
    invoiceRegistered: 'Фактура успешно регистрована',
    invoicesRegistered: 'Пакет фактура успешно регистрован',
    invoicesPartiallyRegistered: 'Пакет фактура је делимично регистрован',
    invoiceExport: 'Извоз',
    invoiceCancelled: 'Отказана',
    invoiceInvalid: 'Одбијена',
    invoiceActive: 'Активна',
    invoicePartiallySettled: 'Започета',
    invoiceReportedInvalid: 'Невалидна',
    invoiceCancelFailed: 'Отказивање фактуре није успело',
    invoiceExportJson: 'Извоз у ЈСОН',
    invoiceExportCsv: 'Извоз у ЦСВ',
    invoiceExportFailed: 'Извоз фактура није успео',
    invoiceSettled: 'Измирена',
    invoiceStatus: {
      0: 'Све',
      1: 'Активна',
      2: 'Одбијена',
      3: 'Отказана',
      4: 'Започета',
      5: 'Измирена',
      6: 'Асигнирана',
      7: 'Профактура',
      101: 'Отворена'
    },
    settlementStatus: {
      1: 'Активно',
      2: 'Отказано'
    },
    invoiceLimitExceeded: 'Лимит на број упућених захтева за регистрацију фактуре достигнут',
    invoiceCurrency: 'РСД',
    invoicesAsDebtor: 'Као дужник',
    invoicesAsCreditor: 'Као поверилац',
    invoicesAsAdministrator: 'Све фактуре',
    invoiceAssigned: 'Асигнирана',
    invoiceAssignedName: 'Назив асигнанта',
    invoiceAssignedBudgetNumber: 'ЈБКЈС асигнанта',
    invoiceAssignedCompanyNumber: 'МБ асигнанта',
    invoiceAssignedTaxIdNumber: 'ПИБ асигнанта',
    invoiceAssignment: 'Асигнација фактуре',
    invoiceAssignmentInformation: 'Информације о асигнацији',
    invoiceAssignmentContractNumber: 'Број уговора асигнације',
    invoiceAssignmentModal: 'Да ли желите да извршите асигнацију фактуре?',
    invoiceAssignmentCancelModal: 'Да ли желите да откажете асигнацију фактуре?',
    invoiceAssignSuccess: 'Асигнација успешно обављена',
    invoiceAssignCancelSuccess: 'Отказивање асигнације успешно обављено',
    invoiceAssignCancel: 'Откажи асигнацију',
    invoiceAssignIdf: 'Идентификатор додељене фактуре',
    invoiceAssignOriginIdf: 'Идентификатор асигниране фактуре',
    invoiceAssignValidDebtorWarning: 'Асигнацију може спровести искључиво локални корисник правног лица које је фактуром задужено : ',
    invoiceAmountChange: 'Измена износа',
    invoiceAmountChangeAdd: 'Додај измену',
    invoiceAmountChangeSettle: 'Измири',
    invoiceAmountChangeSuccess: 'Измена износа успешно обављена',
    invoiceAmountChangeComment: 'Број књижног одобрења/број књижног задужења',
    invoiceDeltaColumnAmount: 'Износ измене',
    invoiceDeltaColumnComments: 'Коментар измене/отказа',
    invoiceDeltaColumnDate: 'Датум измене/отказа',
    invoiceDeltaCancel: 'Откажи измену',
    invoiceSettlementCancel: 'Откажи измирење',
    invoiceActivationCancel: 'Откажи активацију',
    invoiceNotFound: 'Тражена фактура није пронађена',
    invoiceCancelledComment: 'Коментар отказа:',
    expandSections: 'Отвори све секције',
    collapseSections: 'Затвори све секције',
    cancelSettlementSuccess: 'Успешно сте отказали измирење',
    registerSettlementSuccess: 'Успешно сте регистровали измирење'
  },
  registerInvoice: {
    invoice: 'Фактура',
    registerSingleInvoice: 'Појединачни унос',
    registerMultipleInvoices: 'Групни унос',
    invoiceFileInput: 'Учитавање фајла за групни унос фактура',
    invoiceFileBrowse: 'Претражи',
    invoiceFileNoSelection: 'Фајл није одабран',
    invoiceRegistration: 'Регистрација фактуре',
    debtorBudgetId: 'ЈБКЈС дужника',
    invoiceNumber: 'Број фактуре / Број профактуре',
    amount: 'Износ',
    issuePlace: 'Место издавања',
    issueDate: 'Датум издавања',
    comments: 'Коментар',
    registerInvoice: 'Региструј фактуру',
    groupInvoiceRegistration: 'Пређи на групни унос',
    invoiceFileParse: 'Фајл за групни унос фактура није синтаксно исправан',
    registerInvoiceConfirmation: 'Да ли сте сигурни да желите да региструјете фактуру?',
    registerMultipleErrorList: 'Списак грешака групног уноса фактура',
    registerMultipleSuccessList: 'Списак регистрованих фактура',
    registerMultipleCsvHeaderError: 'Недостаје или је погрешно заглавље (енг: header) у CSV fajlu',
    registerProinvoice: 'Профактура',
    registerProinvoiceLifetime: 'Рок важења у данима',
    registerProinvoiceFootnote: '*Уколико се не наведе рок важења, биће коришћена подразумевана вредност',
    registerProinvoiceLifetimeEmpty: 'Рок важења мора бити у опсегу од 1 до 90 дана'
  },
  groupSettlement: {
    groupSettlementReview: 'Преглед спецификација групних плаћања',
    columnGroupSettlementNumber: 'Бр. спецификације',
    columnCreditor: 'Поверилац',
    columnAmount: 'Износ',
    columnAmountFrom: 'Од',
    columnAmountTo: 'До',
    columnDebtor: 'Дужник',
    columnCreationDate: 'Датум креирања',
    columnCreationDateRangeFrom: 'Од',
    columnCreationDateRangeTo: 'До',
    columnDueDate: 'Најближи законски рок измирења',
    columnDueDateRangeFrom: 'Од',
    columnDueDateRangeTo: 'До',
    columnSettlementDate: 'Датум измирења',
    columnSettlementDateRangeFrom: 'Од',
    columnSettlementDateRangeTo: 'До',
    columnStatus: 'Статус',
    columnInvoiceErrorCode: 'Статус унутар спецификације',
    columnInvoiceCount: 'Број фактура',
    groupSettlementCreator: 'Креирао',
    groupSettlementAddInvoices: 'Додај фактуре',
    groupSettlementCancelAddInvoices: 'Одустани',
    groupSettlementStatus: {
      0: 'Све',
      1: 'У току',
      2: 'Активна',
      3: 'Измирена',
      4: 'Отказана',
      5: 'Невалидна'
    },
    invoiceError: 'Грешка',
    groupSettlementInvoicesShowTable: 'Прикажи као табелу',
    groupSettlementInvoicesShowText: 'Прикажи као текст',
    groupSettlementInvoicesShowInput: 'Прикажи као текстуални унос',
    badgeCancelled: 'Отказана',
    badgeInvalid: 'Невалидна',
    badgeSettled: 'Измирена',
    createNew: 'Додај нову спецификацију групног плаћања',
    groupSettlementRegister: 'Нова спецификација групног плаћања',
    invoiceList: 'Листа фактура спецификације',
    groupSettlementNumber: 'Број спецификације групног плаћања',
    settlementAmount: 'Износ',
    invoiceId: 'Идентификатор фактуре',
    groupSettlementSubmit: 'Kreiraj',
    groupSettlementConfirmation: 'Креирати нову спецификацију групног плаћања?',
    groupSettlementEdit: 'Измени',
    groupSettlementEditSave: 'Сачувај',
    groupSettlementEditConfirmation: 'Изменити спецификацију групног плаћања?',
    groupSettlementBack: 'Натраг',
    groupSettlementEditHeader: 'Измени спецификацију групног',
    groupSettlementSingle: 'Спецификација групног плаћања',
    groupSettlementActivate: 'Активирај',
    groupSettlementActivateTitle: 'Активирај спецификацију групног плаћања',
    groupSettlementActivateTitleDisabled: 'Није могуће активирату спецификацију која садржи невалидне фактуре',
    groupSettlementDeactivate: 'Деактивирај',
    groupSettlementDeactivateTitle: 'Деактивирај спецификацију групног плаћања',
    groupSettlementCancel: 'Откажи',
    groupSettlementCancelTitle: 'Откажи спецификацију групног плаћања',
    groupSettlementActivationConfirmation: 'Активирај спецификацију групног плаћања?',
    groupSettlementDeactivationConfirmation: 'Деактивирај спецификацију групног плаћања?',
    groupSettlementCancelationConfirmation: 'Откажи спецификацију групног плаћања',
    groupSettlementActivated: 'Групна спецификација успешно активирана',
    groupSettlementDeactivated: 'Групна спецификација успешно деактивирана',
    groupSettlementCanceled: 'Групна спецификација успешно отказана',
    groupSettlementEdited: 'Успешно сте изменили спецификацију групног плаћања',
    groupSettlementNoEdit: 'Не можете да мењате већ активирану или отказану спецификацију групног плаћања',
    massInput: 'Фактуре са износима',
    massAdditionalInput: 'Фактуре за додавање у спецификацију',
    invoiceTableHeader: 'Фактуре у групној спецификацији',
    review: 'преглед',
    groupSettlementRegistered: 'Спецификација групног плаћања је успешно регистрована',
    massInputError: {
      tableHeader: 'Списак грешака приликом валидације',
      emptyOrTooFew: 'Спецификација групног плаћања мора садржати барем две (2) фактуре',
      malformedLine: 'Линија: {0}, Погрешно форматирана линија',
      nonNumberAmount: 'Линија: {0}, Износ мора бити број',
      duplicateInvoice: 'Линија: {0}, Фактура се већ налази у листи',
      returnedCodePrefix: 'Problem sa fakturom {0}:'
    },
    groupSettlementFetchingData: 'Добављам податке са сервера',
    groupSettlementFetchingDataFailed: 'Дошло је до неуспеха приликом добављања групне спецификације, молимо вас покушајте поново нешто касније',
    groupSettlementRemoveInvoiceConfirmation: 'Да ли сте сигурни да желите да уклоните изабране фактуре из спецификације групног плаћања?',
    groupSettlementAddInvoiceConfirmation: 'Да ли сте сигурни да желите да додате фактуре у спецификацију групног плаћања ',
    groupSettlementRemoveInvoice: 'Уклони изабране фактуре',
    groupSettlementAddInvoice: 'Додај фактуре',
    selectInvalidInvoices: 'Означи невалидне фактуре',
    groupSettlementInvalidBanner: 'Спецификација групног плаћања није валидна. Измените спефицикацију како бисте уклонили све отказане, измирене или асигниране фактуре.',
    groupSettlementActivateLink: 'Информације о активацији'
  },
  userAdministration: {
    userProfile: 'Кориснички профил',
    administration: 'Управљање корисницима',
    localAdministration: 'Управљање локалним корисницима',
    userDetails: 'Детаљи корисничког налога',
    userDetailsChange: 'Измена корисничког налога',
    userCreate: 'Креирање новог корисника',
    userNotification: 'Постављање нотификације',
    userNotificationCancel: 'Откажи нотификацију',
    details: 'Детаљи',
    userId: 'Идентификатор',
    userOrganizationName: 'Назив правног лица/органа',
    userLogin: 'Кориснички налог',
    userName: 'Име и презиме',
    userEmail: 'Електронска пошта',
    userRoles: 'Корисничке улоге',
    userRoleDescription: 'Опис корисничке улоге',
    userClaims: 'Корисничка овлашћења',
    userRolesClaims: 'Корисничке улоге и овлашћења',
    userStatus: 'Статус корисника',
    changePassword: 'Промена шифре',
    oldPassword: 'Стара шифра',
    newPassword: 'Нова шифра',
    confirmNewPassword: 'Потврди нову шифру',
    password: 'Шифра',
    confirmPassword: 'Потврди шифру',
    confirmPasswordFail: 'Нова шифра се не подудара са потврдом шифре',
    passwordChanged: 'Нова шифра успешно постављена',
    userChangedId: 'Опозвао корисник',
    userLastChangeDate: 'Датум опозива',
    userChangedComments: 'Коментар опозива',
    personalInformationChange: 'Промена личних података',
    personalInformationChangeConfirmation: 'Да ли сте сигурни да желите да измените податке корисника?',
    registrationInformationChangeConfirmation: 'Да ли сте сигурни да желите да измените податке о регистрацији?',
    apply: 'Примени',
    userRevoke: 'Опозови',
    userRevokeComments: 'Разлог опозива',
    userRevokeConfirmation: 'Да ли сте сигурни да желите да опозовете корисника?',
    userResetPassword: 'Ресетуј лозинку',
    userResetPasswordConfirmation: 'Да ли сте сигурни да желите да ресетујете креденцијале корисника',
    userPasswordHasBeenReset: 'Успешно сте ресетовали креденцијале корисника',
    userPermissionUpdateConfirmation: 'Уколико је корисник већ пријављен на систем у тренутку доделе нових овлашћења, она ступају на снагу тек када се корисник поново пријави на систем',
    userActivate: 'Активирај',
    userActivateConfirmation: 'Да ли сте сигурни да желите да активирате корисника?',
    userActiveStatus: 'Активан',
    userRevokedStatus: 'Опозван',
    userRevoked: 'Корисник успешно опозван',
    userRestored: 'Корисник успешно активиран',
    userPermissionsUpdated: 'Корисничка овлашћења успешно ажурирана',
    userRevokeFailed: 'Опозив корисника није успео',
    userRestoreFailed: 'Активирање корисника није успело',
    userPermissionsUpdateFailed: 'Ажурирање корисничких овлашћења није успело',
    userPermissionsTableFilter: 'Филтрирај',
    userPermissionsTableFilterClear: 'Уклони филтер',
    userCreateConfirmation: 'Креирати новог локалног корисника?',
    userCreated: 'Нови корисник успешно креиран',
    userUpdated: 'Информације о кориснику успешно измењене',
    registrationUpdated: 'Информације о регистрацији успешно измењене',
    notificationId: 'Идентификатор',
    notificationCreator: 'Поставио',
    notificationText: 'Садржај нотификације',
    notificationPriority: 'Приоритет',
    notificationPriorityStatus: {
      0: 'Све',
      1: 'Низак',
      2: 'Нормалан',
      3: 'Висок'
    },
    notificationValidUntil: 'Датум застаревања',
    notificationCreatedDate: 'Датум постављања',
    notificationCreate: 'Постави нотификацију',
    notificationEdit: 'Измени нотификацију',
    notificationCreated: 'Нотификација успешно постављена',
    notificationUpdated: 'Нотификација успешно измењена',
    notificationFailed: 'Постављање нотификације неуспешно',
    Claim_Admin: 'Администрација',
    Claim_User_Create: 'Креирање корисника',
    Claim_User_Review: 'Преглед корисника',
    Claim_User_Revoke: 'Опозив корисника',
    Claim_Local_User_Create: 'Креирање локалног корисника',
    Claim_Local_User_Review: 'Преглед локалног корисника',
    Claim_Local_User_Revoke: 'Опозив локалног корисника',
    Claim_Invoice_Create: 'Креирање фактуре',
    Claim_Invoice_Cancel: 'Отказивање фактуре',
    Claim_Invoice_Cancel_All: 'Отказивање свих фактура',
    Claim_Invoice_Review: 'Преглед фактуре',
    Claim_Invoice_Review_All: 'Преглед свих фактура',
    Claim_Invoice_Export: 'Извоз фактуре',
    Claim_Invoice_Assign: 'Асигнација фактуре',
    Claim_Invoice_Settle: 'Поравнање фактуре',
    Claim_Invoice_Invalidate: 'Одбијање фактуре',
    Claim_Invoice_User_Settle: 'Корисничко измирење фактуре',
    Claim_Anonymous_Access: 'Анонимни приступ',
    Claim_Notification_Create: 'Постављање нотификације',
    Claim_Registration_Edit: 'Измена регистрације',
    Claim_Registration_Review: 'Преглед регистрације',
    Claim_Invoice_Amount_Change: 'Измена износа фактуре',
    Claim_Invoice_Activate: 'Измена износа измирене фактуре (вишеструка)',
    Claim_Invoice_Activate_Once: 'Измена износа измирене фактуре',
    Claim_Issue_Resolve: 'Затварање рекламације',
    Claim_Group_Settlement_Create: 'Креирање спецификације групног плаћања',
    Role_Administrator: 'Администратор',
    Role_Operator: 'Оператер трезора',
    Role_Local_Administrator: 'Локални администратор',
    Role_Local_User: 'Локални корисник',
    Role_Control: 'Инспекцијска контрола',
    Role_Jafin_User: 'Интегративни сервис ЈАФИН',
    entityStatuses: {
      0: 'Активан',
      3: 'Привремено неактиван',
      9: 'Угашен'
    },
    userStatuses: {
      0: 'Сви',
      1: 'Активан',
      2: 'Неактиван',
      3: 'Опозван',
      4: 'Деактивиран'
    },
    userPasswordRequirement: {
      0: 'Шифра мора садржати најмање 8 карактера',
      1: 'Шифра мора садржати бројеве',
      2: 'Шифра мора садржати велика слова',
      3: 'Шифра мора садржати симболе'
    },
    userLoginRequirement: {
      0: 'Кориснични налог може садржати латинична слова енглеске абецеде',
      1: 'Кориснични налог може садржати бројеве',
      2: 'Кориснични налог може садржати симболе \'.\' , \'_\' ',
      3: 'Кориснични налог мора почети и завршити се са словом или бројем',
      4: 'Кориснични налог може садржати максимално 32 карактера'
    },
    ungroupedClaims: 'Остала овлашћења',
    Role_Administrator_Description: 'Администрација са свим привилегијама и овлашћењима',
    Role_Operator_Description: 'Оператер управе за трезор са овлашћењима креирања приступа систему новим правним лицима/органима',
    Role_Local_Administrator_Description: 'Администрација правних лица/органа',
    Role_Local_User_Description: 'Локални корисник правног лица/органа',
    Role_Control_Description: 'Инспекцијска контрола са овлашћењима за преглед свих фактура',
    Ungrouped_Description: 'Некатегоризована овлашћења корисничких улога'
  },
  userRegistration: {
    registrationHeader: 'Регистрација правног лица/органа',
    registrationInstitution: 'Подаци о правном лицу/органу',
    registrationId: 'Број захтева',
    registrationBudgetId: 'ЈБКЈС',
    registrationCompanyNumber: 'Матични број',
    registrationCompanyNumberShort: 'MB',
    registrationTaxIdNumber: 'ПИБ',
    registrationParentInstitution: 'Надређена институција',
    registrationName: 'Назив правног лица/органа',
    registrationShortName: 'Назив',
    registrationEmail: 'Електронска пошта',
    registrationEntityType: 'Тип КЈС',
    registrationActivity: 'Активност',
    registrationCouncil: 'Место',
    registrationDirectBudgetCode: 'Шифра директног БК',
    registrationPhoneNumber: 'Телефон',
    registrationPostOfficeNumber: 'Поштански број',
    registrationAddress: 'Адреса',
    registrationAdmin: 'Подаци о администратору',
    registrationAdminName: 'Име и презиме',
    registrationAdminIdentityNumber: 'Број идентификационе исправе',
    registrationAdminPersonalIdentityNumber: 'ЈМБГ',
    registrationAdminEmail: 'Електронска пошта',
    registrationAdminPhoneNumber: 'Број телефона',
    registrationCreationDate: 'Датум подношења захтева',
    registrationRegistrationDate: 'Датум регистрације',
    registrationRegistered: 'Регистрован',
    registrationAdminActivate: 'Активација администраторског налогa',
    registrationApproved: 'Регистрација правног лица/органа успешно одобрена',
    registrationCancelled: 'Регистрација правног лица/органа успешно отказана',
    registrationActivate: 'Активирај налог',
    registrationCancel: 'Откажи налог',
    registrationStatus: 'Статус регистрације',
    registrationStatuses: {
      0: 'Сви',
      1: 'У току',
      2: 'Одобрена',
      3: 'Отказана'
    },
    registrationApprovedUser: 'Регистрацију одобрио',
    registrationCancelledUser: 'Регистрацију отказао',
    registrationApprovalDate: 'Датум одобравања',
    registrationCancelConfirmationText: 'Да ли сте сигурни да желите да откажете регистрацију?',
    registrationApproveConfirmationText: 'Да ли сте сигурни да желите да одобрите регистрацију?',
    registrationFormTitle: 'Захтев за регистрацију',
    adminFormTitle: 'Потврда за предају корисничког налога',
    registrationApprovedDate: 'Регистрација одобрена',
    invoiceLimitChangeText: 'Месечни лимит на број регистрованих фактура',
    noInvoiceLimitText: 'Нема лимита',
    invoiceLimitChangedText: 'Месечни лимит на број регистрованих фактура успешно измењен'
  },
  datatable: {
    toggleAll: 'Означи све',
    filter: 'Филтрирај',
    perPage: 'Број приказа по страни',
    range: 'Приказ од {0} до {1} од укупно {2} података',
    rangePartial: 'Приказ од {0} до {1} од преко {2} података',
    noData: 'Нема података',
    generateReport: 'Генериши извештај',
    generateReportModalText: 'Да ли сте сигурни да желите да генеришете извештај према тренутним подацима?'
  },
  message: {
    title: 'Регистар Фактура',
    welcome: 'Добродошао',
    login: 'Пријава',
    documentation: 'Документација',
    signout: 'Одјава',
    profile: 'Профил',
    externalLinks: 'Спољни линкови'
  },
  apiStatusCodes: {
    0: 'Није могуће успоставити конекцију, покушајте поново након пар минута',
    400: 'Обрада захтева није успела',
    401: 'Грешка приликом ауторизације корисника',
    403: 'Немате одговарајуће корисничке привилегије',
    404: 'Није пронађена захтевана страна',
    429: 'Лимит на број упућених захтева је достигнут',
    500: 'Грешка приликом употребе сервиса, молимо контактирајте техничку подршку',
    1001: 'Податак ЈБКЈС није исправан',
    1002: 'Податак ПИБ није исправан',
    1003: 'Податак Матични број није исправан',
    1004: 'Податак ПИБ надређене институције није исправан',
    1005: 'Податак Матични број надређене институције није исправан',
    1006: 'Податак Име компаније или јавног предузећа није исправан',
    1007: 'Податак Адреса седишта није исправан',
    1008: 'Податак Број телефона није исправан',
    1009: 'Податак И-мејл компаније није исправан',
    1010: 'Податак Испостава трезора није исправан',
    1011: 'Податак Име и презиме администратора није исправан',
    1012: 'Податак ЈМБГ администратора није исправан',
    1013: 'Податак Број идентификационе исправе администратора није исправан',
    1014: 'Податак И-мејл администратора није исправан',
    1015: 'Податак Број телефона администратора није исправан',
    1016: 'Податак Број фактуре није исправан',
    1017: 'Податак Износ није исправан',
    1018: 'Податак Датум издавања није исправан',
    1019: 'Податак Коментар није исправан',
    1025: 'Податак Месечни лимит на број регистрованих фактура није исправан',
    1101: 'Податак Кориснички налог није исправан',
    1102: 'Податак Име и презиме корисника није исправан',
    1103: 'Податак Електронска пошта корисника није исправан',
    1104: 'Податак Шифра корисника није исправан',
    1105: 'Унета шифра не задовољава критеријум',
    1107: 'Коментар опозива није исправан',
    1200: 'Фактура није исправна',
    1201: 'Број фактуре није исправан',
    1202: 'Износ није исправан',
    1203: 'Датум издавања није исправан',
    1204: 'Коментар није исправан',
    1205: 'ЈБКЈС дужника није исправан',
    1206: 'Место издавања није исправан',
    1207: 'Идентификатор фактуре није исправан',
    1208: 'Разлог отказивања није исправан или садржи недозвољене симболе',
    1209: 'Број унетих фактура превазилази ограничење',
    1210: 'ЈБКЈС дужника није исправан',
    1211: 'Број уговора асигнације није исправан',
    1212: 'Рок важења мора бити у опсегу од 1 до 90 дана',
    1300: 'Измирење није исправно',
    1301: 'Шифра банке није исправна',
    1302: 'ПИБ повериоца није исправан',
    1303: 'МБ повериоца није исправан',
    1304: 'Износ измирења није исправан',
    1305: 'ЈБКЈС дужника није исправан',
    1306: 'Број фактуре није исправан',
    1308: 'Коментар измирења није исправан',
    1400: 'Нотификација није исправна',
    1401: 'Приоритет нотификације није исправан',
    1402: 'Датум застаревања нотификације није исправан',
    1403: 'Садржај нотификације није исправан',
    1404: 'Статус нотификације није исправан',
    1501: 'Тражени број података по страни није исправан',
    1601: 'Идентификатор фактуре није исправан',
    1602: 'Износ измене није исправан',
    1603: 'Коментар измене није исправан или садржи недозвољене симболе',
    1604: 'Идентификатор измене није исправан',
    1605: 'Коментар отказа измене није исправан или садржи недозвољене симболе',
    1701: 'ЦРФ ресурс није исправан',
    1702: 'Идентификатор ресурса није исправан',
    1703: 'Категорија проблема није исправна',
    1704: 'Додатне информације о проблему нису исправне',
    1705: 'Коментар проблема није исправан',
    1707: 'Коментар оператера није исправан',
    1802: 'Број спецификације групног плаћања садржи невалидне карактере',
    2001: 'Захтев за регистрацију не садржи податке',
    2002: 'ЈБКЈС јавног предузећа није валидан',
    2003: 'МБ и ПИБ приватног правног лица нису валидни',
    2004: 'Захтев за регистрацију већ поднет',
    2005: 'Слање конфирмационог имејла није успело',
    2008: 'Наведена испостава трезора није исправна',
    2009: 'Идентификатор регистрације није наведен приликом отказивања',
    2011: 'Наведени МБ и ПИБ не одговарају унетом ЈБКЈС',
    2012: 'Токен за измену регистрације не садржи валидне податке',
    2013: 'Регистрација коју покушавате да измените је одобрена или отказана',
    2014: 'Покушавате да се региструјете без унетог ЈБКЈС који вам је додељен',
    2901: 'Грешка приликом преузимања података о регистрацији. Молимо контактирајте техничку подршку',
    3000: 'Корисник није регистрован у систему или немате одговарајуће корисничке привилегије',
    3001: 'Кориснички креденцијали нису исправни',
    3002: 'Токен корисника није валидан',
    3003: 'Помоћни токен није пронађен',
    3006: 'Корисник још увек није активиран',
    3007: 'Корисник је опозван',
    3008: 'Дужина шифре није валидна',
    3009: 'Шифра мора садржати бројеве',
    3010: 'Шифра мора садржати велика слова',
    3011: 'Шифра мора садржати симболе',
    3012: 'Корисник је деактивиран',
    3014: 'Прекорачен број неуспелих покушаја, пријава блокирана (у секундама)',
    3015: 'Корисник није валидан или припада погрешној организацији',
    3900: 'Непозната грешка приликом креирања приступног токена',
    3901: 'Непозната грешка приликом генерисања помоћног токена',
    3902: 'Непозната грешка приликом добијања података о кориснику',
    4000: 'Нису пронађене валидне информације за регистрацију корисника',
    4003: 'Наведени корисник није регистрован на систему',
    4006: 'Није пронађен валидан активациони токен',
    4007: 'Корисник је већ активан на систему',
    4009: 'Креирање новог корисника није успело',
    4011: 'Наведени корисник није активан на систему',
    4012: 'Промена статуса није успела или немате одгаваруће привилегије',
    4013: 'Покушано је додавање недозвољених привилегија',
    4017: 'Корисник није у могућности да деактивира самог себе',
    4018: 'Ажурирање привилегија администрације није дозвољено',
    4019: 'Није дозвољено креирање корисника без привилегија',
    4020: 'Активација угашеног корисника није дозвољена',
    4021: 'Измена корисничких информација није успела',
    4022: 'Приоритет нотификације није исправан',
    4023: 'Статус нотификације није исправан',
    4906: 'Грешка приликом активације корисника, молимо покушајте поново',
    4912: 'Непозната грешка приликом измене корисничких података',
    4905: 'Одобравање корисника је неуспешно',
    4915: 'Кориснички тип Оператор није дозвољен за организацију',
    4916: 'Корисничко право за тип Оператор није дозвољено за организацију',
    6001: 'Грешка у валидацији фактуре',
    6002: 'Вишеструка грешка приликом регистрације фактура',
    6003: 'Једна или више фактура није пронађена, проверите валидност броја фактуре',
    6006: 'Тражена фактура је већ измирена',
    6010: 'Овлашћење за отказивање не постоји или је започето измирење',
    6011: 'Тражена фактура је отказана',
    6013: 'Максималан дозвољен број фактура премашен',
    6018: 'Премашена толеранса за измирени износ',
    6019: 'Број фактуре је обавезан',
    6020: 'Број фактуре садржи невалидан почетни симбол',
    6021: 'Број фактуре садржи невалидан крајњи симбол',
    6023: 'Није могућа асигнација већ асигниране фактуре',
    6024: 'Покушана је асигнација од стране невалидног дужника',
    6025: 'Није могућа поновна асигнација већ асигниране фактуре',
    6027: 'Отказивање асигниране фактуре није успело',
    6028: 'Није могуће измирење на асигнираној фактури',
    6029: 'Број фактуре садржи невалидан симбол',
    6030: 'Регистрација фактуре повериоцу није дозвољена',
    6032: 'Премашена дужина броја фактуре - дозвољено 22 карактера',
    6033: 'Унети ЈБКЈС дужника није исправан или дужник више није активан',
    6034: 'Унети ЈБКЈС припада типу правног лица/органа који не може бити дужник',
    6039: 'Измена износа фактуре премашује вредност измиреног износа',
    6041: 'Измена износа фактуре је дозвољена само повериоцу фактуре',
    6042: 'Асигнација фактуре самом себи није дозвољена',
    6043: 'Износ фактуре након измене не сме бити нула',
    6044: 'Унети ЈБКЈС припада правном лицу/органу који не може бити дужник',
    6046: 'Нису пронађене исправне информације о отказу фактуре',
    6047: 'Нису пронађене исправне информације о кориснику који је отказао фактуру',
    6055: 'Категорија проблема не одговара одабраном ЦРФ ресурсу',
    6056: 'Одабрана категорија проблема захтева додатне информације',
    6057: 'Нису пронађене валидне рекламације',
    6060: 'Рекламација није активна или не припада организацији',
    6067: 'Није пронађена валидна групна спецификациј плаћања',
    6068: 'Број групне спецификације плаћања није пронађен',
    6069: 'Број спецификације групног плаћања има погрeшан први карактер',
    6070: 'Број спецификације групног плаћања има погрeшан последњи карактер',
    6071: 'Број спецификације групног плаћања садржи невалидни карактер',
    6072: 'Број спецификације групног плаћања има невалидну дужину',
    6073: 'Поље за фактуре не садржи податке',
    6074: 'Невалидна фактура за спецификацију груног плаћања',
    6075: 'Спецификација групног плаћања садржи исту фактуру више пута',
    6076: 'Ниједна валидна спецификација групног плаћања није сачувана',
    6077: 'Спецификација групног плаћања је празна',
    6078: 'Нема валидних ставки за спецификацију групног плаћања',
    6079: 'Ниједна валидна спецификација групног плаћања није измењена',
    6080: 'Спецификација групног плаћања је отказана',
    6081: 'Спецификација групног плаћања је измирена',
    6082: 'Захтев за спецификацију групног плаћања нема податке',
    6083: 'Захтев за промену статуса спецификације групног плаћања је празан',
    6084: 'Непознат поверилац за спецификацију групног плаћања',
    6085: 'Невалидан износ за спецификацију групног плаћања',
    6086: 'Невалидна ставка за спецификацију групног плаћања',
    6087: 'Невалидан статус за спецификацију групног плаћања',
    6088: 'Спецификација групног плаћања је невалидна',
    6089: 'Невалидан износ за фактуру унутар спецификације групног плаћања',
    6090: 'Спецификација групног плаћања је активна',
    6091: 'Спецификација групног плаћања садржи једну фактуру',
    6092: 'Измирени износ фактуре је промењен за спецификацију групног плаћања',
    6093: 'Износ фактуре је промењен за спецификацију групног плаћања',
    6094: 'Статус фактуре је промењен за спецификацију групног измирења',
    6095: 'Непознат фактура или организација',
    6096: 'Невалидни дужник фактуре',
    6097: 'Максималан дозвољен број фактура за спецификацију групног плаћања премашен',
    6102: 'Датум важења профактуре мора бити у будућности',
    6103: 'Рок важења мора бити у опсегу од 1 до 90 дана',
    6106: 'Фактура је већ регистрована у активној спецификацији групног плаћања',
    6108: 'Прекорачен је месечни лимит за број регистрованих фактура',
    6128: 'Корисничко измирење фактуре је дозвољено само дужницима дате фактуре са привилегијом за измирење фактуре',
    6131: 'Прекорачен је месечни лимит на број отказаних фактура за организацију',
    6144: 'Вредност филтера мора имати минимум 3 карактера',
    6901: 'Непозната грешка приликом регистрације фактуре',
    6902: 'Непозната грешка приликом претраге фактуре',
    6904: 'Отказ фактуре није успео или нисте поверилац фактуре',
    6916: 'Непозната грешка приликом дохватања спецификације групног плаћања',
    54100: 'Регистрацију није могуће одобрити',
    54200: 'Није могуће ажурирати хијерархију корисника',
    54300: 'Корисничко име већ постоји на систему, измените корисничко име па покушајте поново',
    54400: 'Корисника није могуће додати на систем, молимо сачекајте 10 секунди па покушајте поново',
    54500: 'Корисник је већ активан на систему',
    54600: 'Није успело додавање новог локалног корисника',
    54900: 'Покушано је додавање корисника са недозвољеним привилегијама',
    55000: 'Достигнут је максималан број корисника по организацији',
    55100: 'Није дозвољена измена корисника са вишим привилегијама',
    56000: 'Непозната грешка приликом регистрације фактуре',
    56100: 'Унети ЈБКЈС није исправан',
    56200: 'Унета фактура је већ регистрована',
    56700: 'Фактура већ постоји или је већ асигнирана',
    56900: 'Скидање статуса асигнације са фактуре није успело',
    57000: 'Отказивање асигниране фактуре није успело',
    58200: 'Нисте поверилац тражене фактуре или статус фактуре не дозвољава измену износа',
    58400: 'Измена износа не постоји или је већ отказана',
    58500: 'Достигнут је максималан број измена износа фактуре',
    58600: 'Достигнут је максималан број активација фактуре',
    71300: 'Фактура или спецификација групног плаћања са истим подацима је већ регистрована'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Дошло је до грешке. Проверите списак грешака испод',
    token: {
      refreshTokenExpired: 'Обновљиви токен је истекао',
      failedToRefreshToken: 'Грешка приликом добијања приступног токена након освежавања'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Унети критеријум \'{query}\' задовоља више од {limit} резултата. Сузите критеријум или наставите претрагу на {url}',
    urlText: 'spisku KJS'
  },
  notifications: {
    apply: 'Примени',
    title: 'Обавештења',
    subscribe: 'Претплатa на обавештења',
    selectNotificationType: 'Селектујте догађај за који желите да Вас обавештавамо',
    subscribedIssueSuccessfully: 'Успешно сте се претплатили за нотификације за изабрану рекламацију',
    unsubscribedIssueSuccessfully: 'Успешно сте се одјавили са нотификација за изабрану рекламацију'
  },
  userSettings: {
    regionalHeader: 'Лична подешавања',
    regionalSubheader: 'Регионална Подешавања',
    dateFormat: 'Формат датума',
    dateLocalization: 'Локализација датума',
    decimalFormat: 'Децимални формат',
    csvSeparator: '\'CSV\' раздвајач',
    language: 'Језик',
    settingsSavedSuccess: 'Успешно промењена регионална подешавања',
    settingsSavedFail: 'Грешка приликом снимања регионалних подешавања'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sr.js